import { $$ } from '../../lib/dom';

/** Pages listed under "Company" in the primary navigation. */
const COMPANY_CHILDREN = new Set(['/careers', '/contact']);

/** Sets aria-current on the navigation links for the current section. */
export function markActiveNavigation(path: string): void {
  const top = `/${path.split('/')[1] ?? ''}`;
  const group = COMPANY_CHILDREN.has(top) ? '/company' : top;
  $$('[data-nav]').forEach((link) => {
    const active = link.dataset.nav === top || (Boolean(link.closest('.nav-links')) && link.dataset.nav === group);
    if (active) link.setAttribute('aria-current', 'page');
    else link.removeAttribute('aria-current');
  });
}
